import api from 'app/shared/utils/api';
import DispatchConstants from 'app/shared/constants/DispatchConstants';
import Statistic from 'app/shared/model/Statistic';

import appLogger from 'app/shared/loggers/appLogger';

const StatisticsActions = {
    getStats(params = {}) {
        return dispatch => dispatch(api.users.properties.getStats(params))
            .then((result) => {
                if (result.success) {
                    const statisticModel = Statistic(result.response);

                    return dispatch({
                        type: DispatchConstants.STATS_GET_SUCCESS,
                        payload: statisticModel,
                    });
                }
                return dispatch({
                    type: DispatchConstants.STATS_GET_FAIL,
                    payload: result,
                });
            })
            .catch((errorRMWModel) => {
                appLogger.logError({
                    message: errorRMWModel.message,
                    context: 'StatisticsActions.getStats',
                });
                return dispatch({
                    type: DispatchConstants.STATS_GET_FAIL,
                    payload: errorRMWModel,
                });
            });
    },
};

export default StatisticsActions;
